'use client';
import Dialog from '@ui/Dialog';
import useEditAvatarProfileStore from '@/components/store/editAvatarProfileModalSlice';
import React, { useState } from 'react';
import Image from 'next/image';
import EditAvatarProfileForm from './EditAvatarProfileForm';
import { putRequestWithAuth } from 'actions/client-http.actions';
import useEditProfileStore from '@/components/store/editProfileModalSlice';
import useStore from 'stores/store';
import { MULTIPART_FORM_DATA_HEADER } from '@utils/httpService';
import { authorizedServerFetch, revalidatePage } from 'actions/server.actions';
import { updateUserProfile } from 'stores/userActions';
import {
  saveOverviewAsNpAdmin,
  updateNonProfitProfile,
} from 'stores/nonProfitAdminActions';

export default function EditAvatarProfileDialog() {
  const isOpen = useEditAvatarProfileStore((state) => state.open);
  const setIsOpen = useEditAvatarProfileStore((state) => state.setOpen);
  const profileImage = useEditAvatarProfileStore((state) => state.profileImage);
  const profileType = useEditAvatarProfileStore((state) => state.profileType);
  const user = useStore((state) => state.user.profile);

  const [saving, setSaving] = useState(false);

  const nonProfitId = user.nonProfitId;

  function closeModal() {
    setIsOpen(false);
  }

  async function onSubmit(avatarData) {
    const { avatar } = avatarData;
    console.log('avatar', avatar);

    try {
      if (avatar) {
        setSaving(true);
        const formData = new FormData();
        formData.append('avatar', avatar);
        console.log('formData', formData);

        const type = profileType;

        switch (type) {
          case 'user': {
            const { data, ok } = await authorizedServerFetch(
              `/users/me/profile`,
              {
                method: 'PUT',
                body: formData,
              },
            );
            console.log('data', data);
            if (ok) {
              await updateUserProfile(data);
              revalidatePage('/profile/me');
            }
            break;
          }
          case 'npo': {
            const { data, ok } = await authorizedServerFetch(
              `/npo-admin/organization/profile`,
              {
                method: 'PUT',
                body: formData,
              },
            );
            console.log('data', data);
            if (ok) {
              await updateNonProfitProfile(data, nonProfitId);
              revalidatePage('/organization/[slug]');
            }
            break;
          }
          case 'company': {
            revalidatePage('/company/[slug]');
            break;
          }
          default:
            console.log('no type found');
            break;
        }
      }
    } catch (err) {
      console.log('errr', err);
    } finally {
      setSaving(false);
    }

    closeModal();
  }

  return (
    <div>
      <Dialog isOpen={isOpen} onClose={closeModal} maxWidth="lg">
        <div className="flex w-full gap-24 p-6 lg:p-0">
          <div className="hidden items-center lg:flex">
            <Image
              width={333}
              height={303}
              src="/assets/images/onboard-dialog-bg.png"
              alt="background image"
              priority
            />
          </div>
          <div className="flex flex-1 flex-col gap-12">
            <EditAvatarProfileForm
              profileImage={profileImage}
              onSubmit={onSubmit}
              saving={saving}
            />
          </div>
        </div>
      </Dialog>
    </div>
  );
}
